import React from "react";
import { Tag, Tooltip } from "antd";
import * as dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { DATE_FORMAT_DD_MM_YYYY, DATE_FORMAT_DD_MM_YYYY_HH_mm } from "constants/DateConstant";
import { QUOTE_DISPLAY_STATUS, QUOTE_SEND_STATE, getQuoteSendState } from "functions/quotes";

/** Gedeeld door de offertelijst en de offerte-detailpagina. */

export const QUOTE_STATUS_TAG = {
  [QUOTE_DISPLAY_STATUS.OPEN]: { color: "blue", key: "quote.status.open" },
  [QUOTE_DISPLAY_STATUS.EXPIRED]: { color: "orange", key: "quote.status.expired" },
  [QUOTE_DISPLAY_STATUS.CONVERTED]: { color: "green", key: "quote.status.converted" },
  [QUOTE_DISPLAY_STATUS.CANCELLED]: { color: "default", key: "quote.status.cancelled" },
};

export const QuoteSendTag = ({ quote }) => {
  const { t } = useTranslation();
  const sendState = getQuoteSendState(quote);
  switch (sendState.state) {
    case QUOTE_SEND_STATE.SENT:
      return (
        <Tooltip title={sendState.to}>
          <span style={{ fontSize: 13 }}>{dayjs.unix(sendState.at).format(DATE_FORMAT_DD_MM_YYYY_HH_mm)}</span>
        </Tooltip>
      );
    case QUOTE_SEND_STATE.CHANGED:
      return (
        <Tooltip title={t("quote.send_state.changed_tooltip", { version: sendState.version })}>
          <Tag color="orange">{t("quote.send_state.changed")}</Tag>
        </Tooltip>
      );
    case QUOTE_SEND_STATE.FAILED:
      return (
        <Tooltip title={sendState.error}>
          <Tag color="red">{t("quote.send_state.failed")}</Tag>
        </Tooltip>
      );
    default:
      return <Tag>{t("quote.send_state.never")}</Tag>;
  }
};

export const customerLabel = (customer) =>
  customer?.company || [customer?.firstName, customer?.lastName].filter(Boolean).join(" ") || "-";
